import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Tab } from 'semantic-ui-react';

import { POSIcon } from '@publicisgroupe/p-os-components';

import { ImageContainer } from 'types/PageInfoDto';
import { ModuleUriParams } from 'types/types';

import { t } from 'utils/resources';

import PageInfo from './components/PageInfo';
import FAQPage from './components/FAQPage';
import GlossaryPage from './components/GlossaryPage';
import ImageContainerModal from './components/ImageContainerModal';

import './HelpSection.less';

interface Props {
  handleHelpSection: (val: boolean) => void;
}

export const HelpSection = ({ handleHelpSection }: Props) => {
  const { module } = useParams<ModuleUriParams>();
  const [containerModal, setContainerModal] = useState<boolean>(false);
  const [imageContainerData, setImageContainerData] = useState<ImageContainer>();

  return (
    <Container className="help-section-container">
      <POSIcon
        icon="close"
        className="large close-icon"
        onClick={() => handleHelpSection && handleHelpSection(false)}
      />
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={[
          {
            menuItem: t('HelpSection.PageInfo.Title'),
            render: () => (
              <PageInfo
                module={module}
                openImageContainerModal={(image: ImageContainer) => {
                  setContainerModal(true);
                  setImageContainerData(image);
                }}
              />
            ),
          },
          {
            menuItem: t('HelpSection.FAQ.Title'),
            render: () => <FAQPage module={module} />,
          },
          {
            menuItem: t('HelpSection.Glossary.Title'),
            render: () => <GlossaryPage module={module} />,
          },
        ]}
      />
      {imageContainerData?.contentImage && imageContainerData.imageText && (
        <ImageContainerModal
          open={containerModal}
          onCloseModal={() => setContainerModal(false)}
          imageContent={imageContainerData.contentImage}
          imageText={imageContainerData.imageText}
        />
      )}
    </Container>
  );
};
